export default "__VITE_ASSET__kWhanyx1__"